export default __webpack_public_path__ + "static/media/E-commerceRealCase1-moblie.be6bc51c.jpg";